<div class="rounded-button">
  <input type="button" value="Baixar Comprovante" class="btn btn-submit"
  (click)="gerarPDF()">
</div>